var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDisciple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.342 8.94199C24.638 8.68399 25.057 8.62299 25.414 8.78499C25.771 8.94699 26 9.30299 26 9.69499C26 14.006 26 23.413 26 26.495C26 26.761 25.895 27.015 25.707 27.202C25.52 27.39 25.265 27.495 25 27.495H7C6.735 27.495 6.48 27.39 6.293 27.202C6.105 27.015 6 26.761 6 26.495V9.69499C6 9.30299 6.229 8.94699 6.586 8.78499C6.943 8.62299 7.362 8.68399 7.658 8.94199C10.5 11.422 16 16.222 16 16.222C16 16.222 21.5 11.422 24.342 8.94199Z",
    fill: "#B57457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26",
    stroke: "#764C39",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisciple);
export default __webpack_public_path__ + "static/media/icon_disciple.de888e7b199efb3c84d3be391b4df173.svg";
export { ForwardRef as ReactComponent };